import {
    createBrowserRouter,
    RouterProvider
} from 'react-router-dom';
import {UserAttributesContextProvider} from "./context/UserAttributesContext.tsx";
import {theme} from "./theme.ts";
import {MantineProvider} from "@mantine/core";
import {Notifications} from "@mantine/notifications";
import {ModalsProvider} from "@mantine/modals";

import '@mantine/core/styles.css';
import '@mantine/dates/styles.css';
import '@mantine/notifications/styles.css';
import 'mantine-datatable/styles.css';
import "@flexinet/ui-components/style.css"


import {AuthProvider} from "./context/AuthContext.tsx";
import {routesConfig} from "./config/routes.tsx";
import {SessionPermissionsProvider} from "./providers/SessionPermissionsProvider.tsx";
import {
    CognitoContextProvider,
    createAuthAwareQueryClient,
    SessionGuardProvider
} from '@flexinet/auth-components';
import {QueryClientProvider} from "@tanstack/react-query";
import {ReactQueryDevtools} from "@tanstack/react-query-devtools";
import {Provider as ReduxProvider} from "react-redux";

import {store} from "./store";


const router = createBrowserRouter(routesConfig)
const queryClient = createAuthAwareQueryClient()

export const App = () => {

    return (
        <MantineProvider theme={theme}>
            {/* Redux holds row-selection state only (FNP-951); records are React Query's. */}
            <ReduxProvider store={store}>
            <SessionGuardProvider>
                <QueryClientProvider client={queryClient}>
                    <AuthProvider>
                        <CognitoContextProvider>
                            <SessionPermissionsProvider>
                                <UserAttributesContextProvider>
                                    <ModalsProvider>
                                        <Notifications position={'bottom-left'}/>
                                        <RouterProvider router={router}/>
                                    </ModalsProvider>
                                </UserAttributesContextProvider>
                            </SessionPermissionsProvider>
                        </CognitoContextProvider>
                    </AuthProvider>
                    <ReactQueryDevtools initialIsOpen={false}/>
                </QueryClientProvider>
            </SessionGuardProvider>
            </ReduxProvider>
        </MantineProvider>
    );
}

